/*** 
 * 创建人：李珊
 * 时间：2021-3-24
 * 描述：通用字典的查看模态框
 * 更新说明:
 */
 import { Component, OnInit,ViewChild, Input, Output, EventEmitter} from '@angular/core';
 import { KmsService } from "../../../kms.service"
 import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
 @Component({
  selector: 'app-dictionary-view',
  templateUrl: './dictionary-view.component.html',
  styleUrls: ['./dictionary-view.component.css']
})
export class DictionaryViewComponent implements OnInit {
   //模态框组件
   @ViewChild('modal') modal: SwModalframeComponent;
   //绑定数据对象
   models:any={};
   constructor(
     private kmsService: KmsService //请求服务
   ) { }
 
   @Input() param:any;
   @Output() callback = new EventEmitter(); //抛出事件
   ngOnInit() {
     this.clickLoca(this.param)
   }
 
   //查看初始化方法
   clickLoca(readData){
     //数据请求
     let ids ={ids: [readData]}
     this.kmsService.getDictionary(ids).subscribe(data=>{
       if(!data){
         this.modal.toggle()
         this.callback.emit()
       }else  if(data["code"] ==200){
         //成功绑定数据
          this.models=data["data"]
       }
     })
   }
 }
 
